import VueRouter from 'vue-router';
import routes from "./routes";

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes: routes
});

export default router;